module.exports = __webpack_public_path__ + "img/p51.a97edbd0.jpg";